import Decimal from 'decimal.js'

const MAX_DIGITOS = 2
export const formatAmount = (value: Decimal | number | string): string => {
	try {
		const valueDecimal = Decimal(value)
		const valueNumber = valueDecimal.toNumber()
		const isValueInteger = Number.isInteger(valueNumber)
		const digitos = !isValueInteger ? valueNumber.toString().split('.')[1].length : 0
		const _digitos = Math.min(digitos, MAX_DIGITOS)

		return valueDecimal.toFixed(_digitos)
	} catch (error) {
		console.error(error)
		return '?'
	}
}

// start of pseudo unit-tests
/*const testDataArr = [
	'10.00000',
	'10.0000',
	'10.000',
	'10.00',
	'10.0',
	'10.',
	'10',

	'10.12345',
	'10.1234',
	'10.123',
	'10.12',
	'10.1',

	'-10.00000',
	'-10.0000',
	'-10.000',
	'-10.00',
	'-10.0',
	'-10.',
	'-10',

	'-10.12345',
	'-10.1234',
	'-10.123',
	'-10.12',
	'-10.1',

	'0.00000',
	'0.0000',
	'0.000',
	'0.00',
	'0.0',
	'0.',
	'0',

	0.00000,
	0.0000,
	0.000,
	0.00,
	0.0,
	0.,
	0,

	10.00000,
	10.0000,
	10.000,
	10.00,
	10.0,
	10.,
	10,

	-10.00000,
	-10.0000,
	-10.000,
	-10.00,
	-10.0,
	-10.,
	-10,

	'10.test',
	'1f.test',
	'1x.test',
	'1x16.test',
	'0xff.test',
	'0xaa.0xff',
	'0xaa.1234',
]

testDataArr.forEach(item => {
	console.log(`value: ${item} ---> formatValue: ${formatAmount(item)}`)
})*/
// end of pseudo unit-tests